// HeroFoodPure.jsx
export default function HeroCard12() {
  return (
    <>
      <section className="food-hero ">
        {/* diagonal geometric background */}
        <div className="geo-shape " aria-hidden>
          <svg viewBox="0 0 600 600" preserveAspectRatio="none">
           
            <path d="M420 0 L600 0 L600 200 Q520 280 600 360 L460 600 L180 600 Q120 520 40 480 L40 320 Q120 260 120 180 L260 0 Z" fill="#FFC24A"/>
          </svg>
        </div>

        {/* soft glow behind bowl */}
        <div className="bowl-glow " aria-hidden></div>

        {/* decorative crown doodle (small SVG) */}
        <svg className="doodle-crown" viewBox="0 0 64 64" aria-hidden>
          <path d="M6 20 L18 14 L26 26 L38 10 L46 26 L58 18 L58 46 L6 46 Z" fill="none" stroke="#D84E1B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

        {/* floating leaves */}
       

        <div className="food-hero-inner">
          {/* LEFT TEXT */}
          <div className="food-left ">
            <p className="kicker">Welcome to Street Savories</p>
            <h1 className="headline">
              Delicious Delights on <br /> the Move
            </h1>
            <p className="lead">
              Savor the journey with our delectable mobile cuisine, bringing delicious delights right to you!
            </p>

            <button className="btn-order ">Order Online</button>

            {/* thumbnail row */}
            <div className="thumb-row " aria-hidden>
              <div className="thumb shine">
                <img src="https://i.postimg.cc/g2v3W5z5/red-haired-lady-eyeglasses-holds-books-shows-ok-sign.jpg" alt="dish 1" />
              </div>
              <div className="thumb shine">
                <img src="https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg" alt="dish 2" />
              </div>
              <div className="thumb shine">
                <img src="https://i.postimg.cc/NjR1gXDD/young_tender_curly_girl_holding_documents_removebg_preview.png" alt="dish 3" />
              </div>
            </div>
          </div>

          {/* RIGHT VISUALS */}
          <div className="food-right ">
            <div className="bowl-wrap">
              <div className="bowl-card ">
                <img src="https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png" alt="large bowl" />
              </div>
            </div>

            {/* small circular thumbnails on the shape */}
            <div className="circle-c12-thumb-c12 c1 ">
              <div className="edu-avatars">
                <img src="https://i.pravatar.cc/100?img=1" />
                <img src="https://i.pravatar.cc/100?img=2" />
                <img src="https://i.pravatar.cc/100?img=3" />
                <span>24k+ Happy Students</span>
              </div>   </div>
           

            {/* slider dot-c12s (visual) */}
            <div className="slider-dot-c12s-c12" aria-hidden>
              <span className="dot-c12 active"></span>
              <span className="dot-c12"></span>
              <span className="dot-c12"></span>
              <span className="dot-c12"></span>
            </div>
          </div>
        </div>

        <style>{`
        
.edu-avatars { width:240px;
  display: flex;  background: linear-gradient(120deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.28) 45%,
    rgba(255,255,255,0.6) 50%,
    rgba(255,255,255,0.28) 55%,
    rgba(255,255,255,0) 100%);
  align-items: center;
  margin-left: 20px;
}
.edu-avatars img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-left: -10px;
}
.edu-avatars span { margin-left: 15px; opacity: .9; }

/* -------------------------
   HeroFoodPure - Pure CSS
   ------------------------- */
.food-hero {
  position: relative;
  
  padding: 84px 0 120px;
  background: #fff;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #0f1720;
}

/* geometric diagonal shape on right (SVG inside) */
.geo-shape {
  position: absolute;
  right: -12%;
  top: -6%;
  width: 72%;
  height: 120%;
  z-index: 1;
  pointer-events: none;
  filter: drop-shadow(0 30px 40px rgba(0,0,0,0.06));
}
.geo-shape svg { width:100%; height:100%; display:block; }

/* bowl glow behind the bowl for premium look */
.bowl-glow {
  position: absolute;
  right: 8%;
  top: 12%;
  width: 42%;
  height: 56%;
  border-radius: 50%;
  background: radial-gradient(circle-c12, rgba(255,195,74,0.25), rgba(255,195,74,0.06) 45%, transparent 60%);
  filter: blur(28px);
  z-index: 2;
  pointer-events: none;
}

/* crown doodle */
.doodle-crown {
  position: absolute;
  right: 32%;
  top: 8%;
  width: 56px;
  height: 56px;
  z-index: 6;
  opacity: 0.95;
  pointer-events: none;
}

/* floating leaves */
.leaf { position:absolute; width:72px; height:72px; z-index:7; pointer-events:none; transform-origin:center; }
.leaf img{ width:100%; height:100%; object-fit:contain; display:block; }
.leaf-1 { right: 22%; top: 42%; animation: leafFloat 5.2s ease-in-out infinite; }
.leaf-2 { right: 12%; bottom: 8%; animation: leafFloat 6.2s ease-in-out .6s infinite; }
@keyframes leafFloat {
  0% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-12px) rotate(6deg); }
  100% { transform: translateY(0) rotate(0deg); }
}

/* main inner grid */
.food-hero-inner {
  width: 92%;
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  align-items: center;
  position: relative;
  z-index: 6;
}

/* LEFT */
.food-left { padding-left: 18px; z-index: 6; }
.kicker { font-weight:700; color:#F2A93D; margin-bottom:10px; letter-spacing:0.6px; }
.headline { font-size:46px; line-height:1.06; font-weight:800; margin:6px 0 18px; color:#172026; }
.lead { color:#47585a; max-width:62%; margin-bottom:22px; font-size:16px; }
.btn-order {
  display:inline-block;
  background:#f6b84a;
  color:#142028;
  padding:12px 22px;
  border-radius:8px;
  font-weight:700;
  border:none;
  cursor:pointer;
  box-shadow: 0 12px 32px rgba(246,184,74,0.18);
  transition: transform .22s ease, box-shadow .22s ease;
}
.btn-order:hover { transform: translateY(-4px); box-shadow: 0 18px 44px rgba(246,184,74,0.24); }

/* thumbnail row below left (small circle-c12s) */
.thumb-row { display:flex; gap:18px; margin-top:28px; align-items:center; z-index:6; }
.thumb {
  width:88px;
  height:88px;
  border-radius:50%;
  overflow:hidden;
  box-shadow: 0 12px 30px rgba(20,30,40,0.08);
  border:4px solid #fff;
  background:#fff;
  transition: transform .3s ease;
  will-change: transform;
}
.thumb img { width:100%; height:100%; object-fit:cover; display:block; }
.thumb:hover { transform: translateY(-8px); }

/* RIGHT */
.food-right { position: relative; display:flex; align-items:center; justify-content:center; margin-left:70px; border-radius:30%; }

/* big bowl card */
.bowl-wrap { position: relative; z-index: 8; }
.bowl-card {
  width:560px;
  height:560px;
  border-radius: 34px;
  overflow: hidden;
 
  position: relative;
  transition: transform .28s ease;
}
.bowl-card img { width:100%; height:100%; object-fit:cover; display:block; }

/* circle-c12 thumbnails positioned over shape */
.circle-c12-thumb-c12 {
  position:absolute;
 
  z-index:9;
}

/* explicit positions */
.c1 { right: 0%; top: 38%; transform: translateX(12%); }
.c2 { right: 4%; bottom: 16%; }

/* slider dot-c12s (visual only) */
.slider-dot-c12s-c12 {
  position:absolute;
  left:50%;
  transform:translateX(-50%);
  bottom: 8%;
  display:flex;
  gap:10px;
  align-items:center;
  z-index:9;
  background: rgba(0,0,0,0.04);
  padding:8px 12px;
  border-radius:22px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
}
.dot-c12 {
  width:10px; height:10px; border-radius:50%; background:#fff; opacity:.45; box-shadow: 0 3px 8px rgba(0,0,0,0.12);
}
.dot-c12.active { width:28px; height:12px; border-radius:12px; background:#142028; opacity:1; display:inline-block; }

/* ------------- SHINE SWEEP ------------- */
.shine { position: relative; overflow: hidden; }
.shine::before {
  content: "";
  position: absolute;
  top: -120%;
  left: -120%;
  width: 240%;
  height: 240%;
  background: linear-gradient(120deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.28) 45%,
    rgba(255,255,255,0.6) 50%,
    rgba(255,255,255,0.28) 55%,
    rgba(255,255,255,0) 100%);
  transform: translateX(-100%) rotate(12deg);
  transition: transform .9s cubic-bezier(.2,.9,.2,1);
  pointer-events: none;
  mix-blend-mode: overlay;
}
.shine:hover::before { transform: translateX(40%) rotate(12deg); }

/* gentle floating for thumbnails */
@keyframes floatY {
  0% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
  100% { transform: translateY(0); }
}
.thumb, .circle-c12-thumb-c12 { animation: floatY 5.6s ease-in-out infinite; }
.thumb:nth-child(2) { animation-duration:6.2s; }
.circle-c12-thumb-c12.c2 { animation-delay: .6s; animation-duration:6.6s; }

/* responsive */
@media (max-width: 980px) {
  .food-hero-inner { grid-template-columns: 1fr; text-align:center; }
  .lead { max-width:100%; }
  .bowl-card { width:86%; height:420px; margin: 0 auto; }
  .thumb-row { justify-content:center; }
  .geo-shape { display:none; }
  .bowl-glow { display:none; }
  .circle-c12-thumb-c12 { display:none; }
  .slider-dot-c12s-c12 { bottom: -24px; left: 50%; transform: translateX(-50%); }
}
        `}</style>
      </section>
    </>
  );
}
